import http from '../../http-common-admin';

   export const dashboarResumegetAllTurnoID = async (year, universityID, tipoDisplay) =>{
        return  await http.get(`/dashbosrdResume?year=${year}&universityID=${universityID}&tipoDisplay=${tipoDisplay}`);
    }


